/**
 * Handle radio fields
 */
export default {
  methods: {
    /**
     * @vuese
     * Make sure we only register on inputObj for all radio sets
     */
    initRadioButtonList(inputObj) {
      if (this.inputs.find((input) => input.name === inputObj.name)) {
        return null
      }
      inputObj.el = this.form.find(`[name="${inputObj.name}"]`)
      return inputObj
    },
  },
}
